import axios from 'axios';

const API_BASE_URL = process.env.VUE_APP_BASE_EASECOM_API_URL;

// Base URL for your API
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Variable to store the token
let authToken = null;

// Function to get the authentication token
export const generateToken = async () => {
    if (authToken) {
        // Return the token if it is already generated and stored
        return authToken;
    }

    try {
        const response = await api.post('/access/token', {
            email: 'Testmodiway@gmail.com',
            password: 'Abcd@1234',
            location_key: 'ty36191257600',
        });

        const { jwt_token } = response.data.data.token;

        // Store the token
        authToken = jwt_token;
        console.log('Token generated and stored:', jwt_token);
        return authToken;
    } catch (error) {
        console.error('Error generating token:', error);
        throw error;
    }
};

// Function to get inventory details
export const getInventoryDetails = async (skus) => {
    try {
        // Ensure the token is generated
        const token = await generateToken();

        const response = await api.get(`/getInventoryDetailsV3?sku=${encodeURIComponent(skus)}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching inventory details:', error);
        return error.response.data;
        // throw error;
    }
};
